import { render, staticRenderFns } from "./PreviousStatus.vue?vue&type=template&id=ba802d4c&scoped=true&"
import script from "./PreviousStatus.vue?vue&type=script&lang=js&"
export * from "./PreviousStatus.vue?vue&type=script&lang=js&"
import style0 from "./PreviousStatus.vue?vue&type=style&index=0&id=ba802d4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba802d4c",
  null
  
)

export default component.exports